import React from 'react';
import ComplianceDashboardWidget from '@/components/ComplianceDashboardWidget';

const ComplianceDashboardPage = () => {
  return (
    <div className="p-6">
      <ComplianceDashboardWidget compact={false} />
    </div>
  );
};

export default ComplianceDashboardPage;
